import React from "react";
import './HighConvertingSection.css';
import mainImg from './images/main.png';
import actionImg from './images/action.png';
import badgeImg from './images/badge.png';
import headingImg from './images/heading.png';
import imageOne from './images/imageOne.png';
import imageTwo from './images/imageTwo.png';
import imageThree from './images/imageThree.png';

export default function HighConvertingSection(){
    return(
        <div className="container-fluid high_converting_section_parent_wrapper py-3">
            <div className="high_converting_section_child_wrapper py-2">
                <div className="container gradient-bg">
                    <h3 className="font-weight-bolder case-study-heading">
                        DESIGNING  A  HIGH <br /> CONVERTING LANDING PAGE
                    </h3>
                    <h5 className="mt-3 px-4 py-2 bg-primary backwards text-white d-none d-sm-none d-md-block" style={{width:180}}>
                        Backwards Case Study
                     </h5>
                     <div className=" d-flex d-sm-flex justify-content-center d-md-none">
                        <h5 className="mt-3 px-4 py-2 bg-primary backwards text-white" style={{width:180}}>
                            Backwards Case Study
                        </h5>
                     </div>
                    <div className="col-12 col-sm-12 col-md-5 mt-5">
                        <img src={mainImg} alt="" className="img-fluid mx-auto" />
                    </div>
                    <h3 className="background_title font-weight-bolder mt-5">
                        Background
                    </h3>
                    <p className="case_study_description mt-4">
                        In today's digital world, a well-designed and effective landing page is crucial for businesses to convert online visitors into customers, subscribers, or leads. 
                        Landing pages serve as the entry point for potential customers and play a pivotal role in a company's digital marketing strategy. 
                        However, many businesses struggle with landing pages that underperform and fail to achieve their conversion goals.
                    </p>
                    <h3 className="background_title font-weight-bolder mt-5">
                        Problem
                    </h3>
                    <p className="case_study_description mt-4">
                        Many businesses invest substantial resources in driving traffic to their landing pages through advertising and marketing campaigns. 
                        The problem at hand is that a significant number of businesses are experiencing low conversion rates on their landing pages and this hinders their ability to meet their marketing objectives 
                        When these efforts do not translate into conversions, it results in wasted marketing spend and poor return on investment (ROI).
                    </p>
                    <h3 className="background_title font-weight-bolder mt-5">
                        Objective
                    </h3>
                    <p className="case_study_description case_study_objective mt-4">
                        The primary objective of this case study is to identify the root causes of low conversion rates on landing pages and develop effective design and 
                        user experience solutions that will lead to increased conversions. 
                    </p>
                    <h3 className="background_title font-weight-bolder mt-5 d-none">
                        Pre approach / process 1
                    </h3>
                    <p className="case_study_description mt-4 d-none">
                        After finding out the goal and the problem with the product I did what I call 
                        text-book and internet research. I conducted research on how to design and develop a 
                        high converting landing page and then used the data & information gathered to begin 
                        the second stage or Approach / Process 2 will we will see shortly after seeing the solution on how we solved the problem.
                    </p>
                    <div className="row mt-5 d-none">
                        <div className="col-12 col-sm-12 col-md-6">
                            <h6 className="">
                                <b>Comprehensive Research & Analysis :</b> <br /><br />
                                <span className="case_study_objective">
                                    Thoroughly investigate the landing pages in question, examining conversion & content elements, layout + hierarchy, call-to-actions, and user flows to identify areas of improvement.
                                </span>
                            </h6>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6">
                            <h6 className="">
                                <b>Identify Conversion Barriers</b> <br /><br />
                                <span className="case_study_objective">
                                    Thoroughly investigate the landing pages in question, examining conversion & content elements, layout + hierarchy, call-to-actions, and user flows to identify areas of improvement.
                                </span>
                            </h6>
                        </div>
                    </div>
                    <div className="row mt-3 d-none">
                         <div className="col-12 col-sm-12 col-md-6">
                            <h6 className="">
                                <b>Identify Conversion Barriers</b> <br /><br />
                                <span className="case_study_objective">
                                    Thoroughly investigate the landing pages in question, examining conversion & content elements, layout + hierarchy, call-to-actions, and user flows to identify areas of improvement.
                                </span>
                            </h6>
                        </div>
                    </div>
                    <h3 className="background_title font-weight-bolder mt-5">
                        The Solution
                    </h3>
                    <p className="case_study_description mt-4">
                        After a thorough two comprehensive researches & analysis of our & competitor landing page design, user experience, 
                        and conversion elements, & other several key 
                        recommendations have been identified to address the issue of low conversion rates. 
                        These include compelling call-to-action design, persuasive copywriting, visual enhancements, trust-building elements, social proof, 
                        mobile optimization, urgency tactics, privacy assurance, and continuous A/B testing
                    </p>
                    <div className="row g-3 mt-4 d-none">
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card-img-top">
                                <div className="col-12 col-sm-12 col-md-3 mt-3">
                                    <img src={actionImg} alt="" className="img-fluid" />
                                </div>
                            </div>
                            <div className="mt-5">
                                <h6 className="solution_title font-weight-bold mt-3">
                                    Revamped Call-To-Actions
                                </h6>
                                <p className="case_study_description mt-4">
                                    I incorporated visually prominent CTA’s with high-contrast colours & action orientated labels such as 
                                    Sign-Up Now or Start Free Trial & 
                                    strategically placed them throughout the page to maintain user focus & encourage actions.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card-img-top">
                                <div className="col-12 col-sm-12 col-md-3 mt-3">
                                    <img src={badgeImg} alt="" className="img-fluid" />
                                </div>
                            </div>
                            <div className="mt-5">
                                <h6 className="solution_title font-weight-bold mt-3">
                                    Trust Building Elements
                                </h6>
                                <p className="case_study_description mt-4">
                                    I incorporated trust building elements such as certifications , badges , industry awards , 
                                    testimonials , reviews and 
                                    user-generated content such as photos & videos to build credibility & trust
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4">
                            <div className="card-img-top">
                                <div className="col-12 col-sm-12 col-md-3 mt-3">
                                    <img src={headingImg} alt="" className="img-fluid" />
                                </div>
                            </div>
                            <div className="mt-5">
                                <h6 className="solution_title font-weight-bold mt-3">
                                    Persuasive Copywriting
                                </h6>
                                <p className="case_study_description mt-4">
                                I incorporated compelling , persuasive headlines with clear & concise value proposition 
                                and emphasized the benefits that the customers will get for choosing 
                                our products  
                                </p>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="row custom-row gx-4 mt-5">
                        <div className="col-12 col-sm-12 col-md-4 custom-col">
                            <img src={imageOne} alt="" className="img-fluid mx-auto" />
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 d-flex justify-content-center flex-column custom-col">
                            <h6 className="solution_title font-weight-bold">
                                Persuasive Copywriting
                            </h6>
                            <h6 className="sub_description mt-2">
                                I incorporated persuasive headlines with clear & concise value proposition 
                                that emphasized the benefits that the customers will get for choosing 
                                our products 
                            </h6>

                            <h6 className="solution_title font-weight-bold mt-4">
                                Revamped Call-To-Actions
                            </h6>
                            <h6 className="sub_description mt-2">
                                I incorporated visually prominent CTA s with high-contrast colours & action orientated labels such as 
                                Sign-Up Now or Start Free Trial  & strategically placed them throughout the page to maintain user focus 
                                & encourage actions. <b><i>Visual Affordance + Verbal | textual affordance</i></b>
                            </h6>

                            <h6 className="solution_title font-weight-bold mt-4">
                                Visual Enhancements:
                            </h6>
                            <h6 className="sub_description mt-2">
                                I incorporated high-quality visuals, such as images and videos, to communicate 
                                product value and use cases.
                            </h6>

                        </div>
                    </div>
                    <div className="row custom-row gx-4 mt-3">
                        <div className="col-12 col-sm-12 col-md-4 custom-col">
                            <img src={imageTwo} alt="" className="img-fluid mx-auto" />
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 d-flex justify-content-center flex-column custom-col">
                            <h6 className="solution_title font-weight-bold">
                                Trust Building Elements
                            </h6>
                            <h6 className="sub_description mt-2">
                                I strategically placed & incorporated trust building elements such as certifications , 
                                badges , industry awards , 
                                testimonials to build credibility & trust
                            </h6>

                            <h6 className="solution_title font-weight-bold mt-4">
                                Social Proof and User Feedback
                            </h6>
                            <h6 className="sub_description mt-2">
                                I incorporated social proof elements such as user testimonials, reviews, and 
                                ratings prominently on the landing page
                                to build credibility & trust
                            </h6>

                            <h6 className="solution_title font-weight-bold mt-4">
                                Mobile Optimization
                            </h6>
                            <h6 className="sub_description mt-2">
                                I Ensured the landing page is fully responsive and optimized for mobile devices to provide a 
                                seamless user experience across all screen sizes.
                            </h6>

                        </div>
                    </div>
                    <h3 className="background_title font-weight-bolder mt-4">
                        Approach
                    </h3>
                    <p className="case_study_description mt-4">
                        Because I knew the problem statement of the problem I was solving 
                        I divided my project into two <b> research approaches </b> 
                        <br />
                        <span>
                            1. What I call <b>Text-book / internet research</b>
                        </span>
                        <br />
                        <span>
                            2. Complete UX Process diveded into phases
                        </span>
                    </p>
                    <br />
                    <div className="d-none d-sm-none d-md-block">
                        <img className="case_study_img" width="56" height="56" src="https://img.icons8.com/3d-fluency/94/reading.png" alt="reading"/>
                        <img className="case_study_img" width="56" height="56" src="https://img.icons8.com/3d-fluency/188/google-logo.png" alt="google-logo"/>
                    </div>
                    <div className="mobile_img d-flex d-sm-flex d-md-none align-items-center justify-content-center">
                        <img className="case_study_img" width="56" height="56" src="https://img.icons8.com/3d-fluency/94/reading.png" alt="reading"/>
                        <img className="case_study_img" width="56" height="56" src="https://img.icons8.com/3d-fluency/188/google-logo.png" alt="google-logo"/>
                    </div>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black"}}>
                        A. Text-book / Internet Research : 
                    </h5>
                    <p className="case_study_description_2 mt-3">
                        I did comprehensive research on how to design and develop a high converting 
                        landing page using <u>Chat GPT</u> , Articles , Blogs and other external case studies.
                    </p>
                    <p className="case_study_description_2 mt-2">
                        <b className="solution_title">
                            This was idealy to help me with knowing which parameters + variables to base 
                            my UX Research Phase on
                        </b>
                    </p>
                    <p className="case_study_description_2">
                        When I began my UX Research process I knew which 
                        parameters | variables | elements to base my 
                        Research Interviews and Competitor Analysis on
                    </p>
                    <p className="case_study_description_2">
                        &nbsp;<b><u>for example</u></b>&nbsp;
                        <span>
                            Conversion elements such as call-to-actions elements  + social proof elements + 
                            visual enhancements   
                        </span>
                    </p>
                    <h3 className="background_title font-weight-bolder mt-5">
                        Discovery of textbook/internet research
                    </h3>
                    <h5 className="font-weight-bold solution_title mt-4" style={{color:"black",fontSize:"17pt"}}>
                        1. Value Proposition 
                    </h5>
                    <p className="case_study_description_2" style={{marginTop:"4vh"}}>
                        <b>Value Proposition Benefits </b> :
                        I discovered that landing pages I am designing should always have a clear concise value proposition 
                        incorporated in headings to
                        highlight the specific benefits or advantages that the customer
                        will  receive from using or choosing the product or service that I am designing and make sure these benefits directly address the customer's
                        pain points , desires and needs.
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Examples </b> : <br />
                        a.  Transform Your Business with Our Cutting-Edge Software <br />
                        b.  Secure Your Future with Our Investment Strategies <br />
                        c.  Maximize Your Productivity with Our Time Management Tools
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Emotions </b> :
                        I discovered that the value proposition should appeal and evoke the emotional needs or desires of the customer and give them reasons 
                        to choose the product or service that I am designing.
                    </p>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black",fontSize:"17pt"}}>
                        2. Strong call-to-actions
                    </h5>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b>Prominent CTA's with Affordance </b> :
                        I discovered that call-to-actions (buttons) should always use high-contrasting colors 
                        with clear labelling that instruct the customers which actions they should take <i>( eg "Sign-up Now" , "Start Free Trial")</i>, 
                        and they should 
                        always look like they can actually be interacted with 
                        this is called <b><i>Affordance Technique</i></b>
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Sense of urgency call-to-actions</b> other set of call-to-actions can be incorporated 
                        on sub-headings as well are those call-to-actions that have a sense of urgency and 
                        psychologically prompt the user to take quick action fearing they might miss out on a time-limited opportunity
                        <br /><br /> <b>Example</b><br />
                        a. Experience Our Software with a 7-Day Free Demo : <b className="text-primary">Request a Demo  Now</b> <br />
                        b. Take the First Step with a 60-Day Investment Trial : <b className="text-primary">Start Building Wealth Today</b> <br />
                        c. Boost Your Efficiency with Our 21-Day Free Trial : <b className="text-primary">Start Free Trial</b>
                    </p>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black",fontSize:"17pt"}}>
                        3. Maintain Attention
                    </h5>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b> Engaging Value Proposition Headline </b> :
                        I discovered that I should always ensure that I come up with a compelling, clear , 
                        concise attention grabbing headline that immediately communicates 
                        the value or benefit the visitors will 
                        receive from the product or website you are designing.
                    </p>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b> Keep a clean and focused layout  </b> :
                        I discovered that I should always make sure that my designs are cluttered-free designs.
                        any distructions should be removed and the layout should be 
                        simple and concise ensuring that the design elements direct customers attention
                        to main call to action’s and the value proposition elements.
                    </p>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b>High Quality Use Case Visuals  </b> :
                        I discovered that I should always try to incorporate high quality visuals such as 
                        images and videos, to communicate product value and use cases of the product effectively
                    </p>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black",fontSize:"17pt"}}>
                        4. Excellent Social Proof
                    </h5>
                    <p className="case_study_description_2 mt-4">
                        <b>Social Proof elements : </b>
                        I discovered that designs should always include trust-building elements such as 
                        customer reviews, testimonials, certifications, security badges, 
                        because these guarantees to instil confidence and trust in visitors
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Testimonials : </b>
                        Testimonials is proven to instil confidence and trust in visitors
                        <br /><br />
                        <b>Example : </b><br /> "The demo was eye-opening! It showed us the potential of this software. We're excited to integrate it into our workflow 
                        to streamline our operations."
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Additional social proof through subheadings</b>: 
                        subheadings on our websites can be used to build trust after grabbing 
                        the attention of the user to keep maintaining their attention
                        <br /> <br />
                        <b>Examples </b> : <br /><br />
                        a.  Trusted by 1,000+ Businesses for Streamlined Operations <br />
                        b.  5-Star Rated by 10,000+ Users Who Boosted Their Efficiency <br />
                        c.  Join 10 000 people who trust us with their money & livelyhood
                    </p>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black",fontSize:"17pt"}}>
                        5. Benefits
                    </h5>
                    <p className="case_study_description_2 mt-4">
                        Users/customers always want to know how is this solution/service 
                        going to assist me in overcoming my challanges and solve my problems,
                        so incorporating benefits that appeal and envoke emotions is always effective
                    </p>
                    <p className="case_study_description_2 mt-4">
                        <b>Examples </b> : <br /><br />
                        <b>Boost Efficiency </b>: Our software streamlines your workflow, automates tasks, and reduces manual work, 
                        allowing your business to operate more efficiently. <br />
                    </p>
                    <p className="case_study_description_2 mt-1">
                        <b>Enhanced Productivity</b> : Experience increased productivity with our intuitive 
                        tools 
                        that help your team work smarter, not harder, saving you time and resources.
                    </p>
                    <p className="case_study_description_2 mt-1">
                        <b>Stay Ahead of the Curve </b>: By leveraging our cutting-edge software, you'll stay competitive and adapt to market changes swiftly, 
                        giving your business a strategic advantage.
                    </p>
                    <img className="mt-5" width="64" height="64" src="https://img.icons8.com/external-nawicon-detailed-outline-nawicon/64/228BE6/external-Interview-recruitment-nawicon-detailed-outline-nawicon.png" alt="external-Interview-recruitment-nawicon-detailed-outline-nawicon"/>
                    &nbsp;&nbsp;
                    <img className="mt-5" width="64" height="64" src="https://img.icons8.com/dotty/80/228BE6/fine-print.png" alt="fine-print"/>
                    <h5 className="font-weight-bold solution_title mt-4" style={{color:"black"}}>
                        B. Research & Analysis : 
                    </h5>
                    <p className="case_study_description_2 mt-3">
                        I conducted competitor analysis research using the data and information I gathered
                        from the text-book + internet research phase I mentioned earlier , 
                    </p>
                    <p className="case_study_description_2 mt-2">
                        <u>I based my competitor analysis on conversion elements and social proof elements : </u>
                    </p>
                    <img className="mt-3" width="46" height="46" src="https://img.icons8.com/external-outline-wichaiwi/64/228BE6/external-call-to-action-digital-marketing-outline-wichaiwi.png" alt="external-call-to-action-digital-marketing-outline-wichaiwi"/>
                    <h5 className="font-weight-bold solution_title mt-3" style={{color:"black",fontSize:"17pt"}}>
                        Call-to-actions
                    </h5>
                    <p className="case_study_description_2 mt-3">
                        I went on competitors landing pages and examined the following conversion & social proof elements : 
                    </p>
                    <p className="case_study_description_2" style={{lineHeight:"25pt"}}>
                        <b>Placement</b> : I analyzed if the CTA’s strategically placed  & asked myself, are they easily noticeble & accessible ?
                    </p>
                    <p className="case_study_description_2">
                        <b>Design & Color</b> : I asked myself if their CTA’s stand out from the rest of the elements on the page and if high-contrast colours were used to draw attention to them ?
                    </p>
                    <p className="case_study_description_2">
                        <b>Wording</b> : I examined if they were action-oriented and compelling users to take action? Do they have effective phrases like 
                        &nbsp; <i>" Start Trial " " Sign Up Now " or " Try for Free. "</i>
                    </p>
                    <h5 className="font-weight-bold solution_title mt-5" style={{color:"black",fontSize:"17pt"}}>
                        Copyrighting and content strategy
                    </h5>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b> Persuasive Techniques: </b> :
                        I analysed their persuasive techniques to see if they use techniques such as 
                        scarcity, urgency, social proof, and authority like the textbook research shown
                        and how I can improve ours and make them more better
                    </p>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b> Emotional Appeal: </b> :
                        I analysed their story telling techniques and how they use them to tap into 
                        users/customers emotions
                    </p>
                    <p className="case_study_description_2 mt-4" style={{marginTop:"4vh"}}>
                        <b> Clarity and complexity  </b> :
                        I analysed the type of language they use to convey their messaeges
                        is it clear conscise and easy to understand what was their trategies
                    </p>
                </div>
            </div>
        </div>
    );
}